export default __webpack_public_path__ + "static/media/googleplay_badge.721ff620.png";